import { render, staticRenderFns } from "./EvenementCard.vue?vue&type=template&id=32842018&"
import script from "./EvenementCard.vue?vue&type=script&lang=js&"
export * from "./EvenementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports